import React from 'react';
import Breadcrumb from '../../components/Breadcrumb';
import FaqOne from '../../components/Faq';
import Button from '../../components/Button';

const FaqMain = () => {
  // Accordion items
  const leftItems = [
    {
      id: 'a',
      itemCount: 1,
      btnText: 'What services does the clinic offer xxx?',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.`,
    },
    {
      id: 'b',
      itemCount: 2,
      btnText: 'How do I schedule an appointment?',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.`,
    },
    {
      id: 'c',
      itemCount: 3,
      btnText: 'How long is the average wait time for appointments?',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.`,
    },
  ];
  const rightItems = [
    {
      id: 'a',
      itemCount: 4,
      btnText: 'What if I do not have insurance?',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris,`,
    },
    {
      id: 'b',
      itemCount: 5,
      btnText: 'What safety measures are in place for COVID-19?',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.`,
    },
    {
      id: 'c',
      itemCount: 6,
      btnText: 'What are the clinic hours of operation?',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.`,
    },
    {
      id: '7',
      itemCount: 7,
      btnText: 'Can I request prescription refills or test results online?',
      description: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut 
        labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris.`,
    },
  ];

  return (
    <main>
      <Breadcrumb title="Faq" />

      <div className="it-faq-area pt-120 pb-90">
        <div className="container">
          <div className="row">
            <div className="col-xl-12">
              <div className="it-faq-title-box text-center mb-65">
                <span className="it-section-subtitle">
                  FREQUENTLY ASKED QUESTIONS
                </span>
                <h3 className="it-section-title">
                  Get Every Single Answer <br /> There If You Want
                </h3>
              </div>
            </div>
          </div>
          <div className="row gx-35">
            <div className="col-lg-6">
              <div className="it-faq-wrap mb-30">
                <FaqOne items={leftItems} hasPreExpanded />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="it-faq-wrap mb-30">
                <FaqOne items={rightItems} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="it-contact-area it-appointments-inner-style pb-120">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="it-contact-from-wrap text-center z-index">
                <h3 className="it-section-title pb-50">
                  Have Any Other Question?
                </h3>
                <form action="#">
                  <div className="row">
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="text" placeholder="Name" />
                      </div>
                    </div>
                    <div className="col-sm-6 col-12 mb-20">
                      <div className="it-contact-input-box">
                        <input type="email" placeholder="Email Address" />
                      </div>
                    </div>
                    <div className="col-12 mb-30">
                      <div className="it-contact-input-box">
                        <textarea placeholder="Type Appointment Note....."></textarea>
                      </div>
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="it-btn-theme d-flex justify-content-center align-items-center w-100"
                  >
                    <Button btnText="BOOK AN APPOINTMENT" />
                  </button>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default FaqMain;
